import styled from "styled-components/macro";

// Hides text on screen but, unlike display: none, keeps it in the accessibility tree
const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
`;

export default VisuallyHidden;
